import { Divider } from '../Divider';

const SidebarDivider = () => <Divider rcx-sidebar--divider mbs={-2} mbe={0} />;

export default SidebarDivider;
